// extracted by mini-css-extract-plugin
export default {"headerComponent":"styles_headerComponent__1yu5E"};